import { z } from 'zod';
import { articleBodySchema } from './blocks';
import { articleCategorySchema } from './primitives';

/** What a writer edits and saves. Server derives slug, read_time, search_text. */
export const articleDraftSchema = z.object({
  title: z.string().trim().min(1, 'Title is required').max(200),
  excerpt: z.string().trim().max(320, 'Excerpt must be 320 characters or fewer').default(''),
  category: articleCategorySchema,
  coverUrl: z.string().url('Enter a valid image URL').or(z.literal('')).optional(),
  body: articleBodySchema,
});
export type ArticleDraftInput = z.infer<typeof articleDraftSchema>;

/** Admin moderation decision on a pending article. */
export const reviewDecisionSchema = z.enum(['approve', 'reject']);
export type ReviewDecision = z.infer<typeof reviewDecisionSchema>;

export const reviewArticleSchema = z.object({
  articleId: z.string().uuid(),
  decision: reviewDecisionSchema,
});
export type ReviewArticleInput = z.infer<typeof reviewArticleSchema>;
